exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root-link[data-v-92f26b20]{font-size:13px;font-weight:700;color:var(--secondary-color);border:none;background:#fff;text-decoration:none;float:right;white-space:nowrap;padding-top:3px}.root-link[data-v-92f26b20]:hover{font-weight:bolder;color:#6a6aff}.action-container .btn[data-v-92f26b20]{width:100%;height:30px;overflow:hidden}.cancel-dl-btn[data-v-92f26b20]{background:transparent;border:none;color:red;font-size:14px;float:right}", ""]);

// exports
